module.exports = __webpack_public_path__ + "img/f5-2.f5c6c9de.jpg";